<template>
  <div class="flex flex-col w-full">
    <Nav style="margin-bottom: 60px" :data="navItems" />

    <div v-for="section in data.sections" :key="section.title" :id="section.id">
      <Custom v-if="section.type == 'custom'" :custom="section" html=true />
      <Bot v-if="section.type == 'bot'" :custom="section" html=true />
    </div>

  </div>
</template>

<script>
import data from "@/data/config.json";

import Nav from "@/components/Navigation.vue";
import Bot from "@/components/Bot.vue";
import Custom from "@/components/Custom.vue";

export default {
  name: "home",
  data() {
    return {
      data,
      category: { users: [] },
      categories: [],
      sections: null
    };
  },
  components: {
    Nav,
    Custom,
    Bot
  },
  created() {
   this.sections = this.data.sections;
  },
  methods: {
  },
  computed: {
    navItems() {
      var navArray = this.sections.map(function(el) {
              if (el.id) {
                return {
                  title: el.title,
                  id: el.id,
                } 
              }
            });
      return navArray.filter(function (el) {
          return el != null;
      });
    }
  }
};
</script>
